// @flow

import type { Action } from '../types/actions/questsfilters'

export const SET_QUESTS_AUTHOR_FILTERS = 'SET_QUESTS_AUTHOR_FILTERS'
export const SET_QUESTS_TAG_FILTERS = 'SET_QUESTS_TAG_FILTERS'
export const SET_QUESTS_KEYWORD_FILTER = 'SET_QUESTS_KEYWORD_FILTER'
export const SET_QUESTS_DRAFT_FILTER = 'SET_QUESTS_DRAFT_FILTER'
export const SET_QUESTS_STATUS_FILTER = 'SET_QUESTS_STATUS_FILTER'
export const SET_QUESTS_PRIMARY_SUBJECT_FILTER =
  'SET_QUESTS_PRIMARY_SUBJECT_FILTER'
export const SET_QUESTS_ASSIGNED_TO_FILTERS = 'SET_QUESTS_ASSIGNED_TO_FILTERS'
export const CLEAR_QUESTS_FILTERS = 'CLEAR_QUESTS_FILTERS'
export const SET_QUESTS_TARGET_GRADE_LEVEL_FILTERS =
  'SET_QUESTS_TARGET_GRADE_LEVEL_FILTERS'
export const SET_QUESTS_COURSE_FILTER = 'SET_QUESTS_COURSE_FILTER'
export const SET_QUESTS_LEVELS_FILTER = 'SET_QUESTS_LEVELS_FILTER'
export const SET_QUESTS_REVIEW_TRACKING_STATUS =
  'SET_QUESTS_REVIEW_TRACKING_STATUS'

export function setAuthorFilters(authorIds: Array<number>): Action {
  return {
    type: SET_QUESTS_AUTHOR_FILTERS,
    authors_id_in: authorIds
  }
}

export function setTagFilters(tagIds: Array<number>): Action {
  return {
    type: SET_QUESTS_TAG_FILTERS,
    questtags_id_in: tagIds
  }
}

export function setKeywordFilter(keyword: string): Action {
  return {
    type: SET_QUESTS_KEYWORD_FILTER,
    name_or_description_cont: keyword
  }
}

export function setDraftFilter(val: boolean): Action {
  return {
    type: SET_QUESTS_DRAFT_FILTER,
    reviewing_compiled_quest_state_null: val
  }
}

export function setStatusFilter(statuses: Array<string>): Action {
  return {
    type: SET_QUESTS_STATUS_FILTER,
    reviewing_compiled_quest_state_in: statuses
  }
}

export function setPrimarySubjectFilter(subjects: Array<string>): Action {
  return {
    type: SET_QUESTS_PRIMARY_SUBJECT_FILTER,
    quest_subject_id_in: subjects
  }
}

export function clearSearchFilters(): Action {
  return {
    type: CLEAR_QUESTS_FILTERS
  }
}

export function setAssignedToFilters(assignedToIds: Array<number>): Action {
  return {
    type: SET_QUESTS_ASSIGNED_TO_FILTERS,
    assigned_to_id_in: assignedToIds
  }
}

export function setTargetGradeLevelFilter(gradeLevels) {
  return {
    type: SET_QUESTS_TARGET_GRADE_LEVEL_FILTERS,
    grade_levels_id_in: gradeLevels
  }
}

export function setCourseFilter(courseId) {
  return {
    type: SET_QUESTS_COURSE_FILTER,
    mock_course_id_in: courseId
  }
}

export function setLevelFilter(levels) {
  return {
    type: SET_QUESTS_LEVELS_FILTER,
    mock_level_id_in: levels
  }
}

export function setReviewTrackingStatus(status) {
  return {
    type: SET_QUESTS_REVIEW_TRACKING_STATUS,
    status
  }
}



// WEBPACK FOOTER //
// ./src/actions/questsfilters.js